module.exports = __webpack_public_path__ + "static/media/Cats Eyes 01-SVENSKA-mixdown.3dd452a9.mp3";